import React, {Suspense} from 'react';
import {Typography} from '@mui/material';

import {translations} from 'presentation/translations-new';
import {SkeletonData} from 'presentation/components/ChangeData/SkeletonData';
import {LocationField} from 'presentation/pages/private/profile/components';
import {CustomBox} from './styles';
import {InitialLocationCardProps} from './types';

const {appointmentCity} = translations['pt-br'].privateFlow.profile;

export function InitialLocationCard({flowType}: InitialLocationCardProps) {
	return (
		<CustomBox>
			<Typography variant="subtitle2" color="text.secondary">
				{appointmentCity}
			</Typography>
			<Suspense fallback={<SkeletonData type="location" />}>
				<LocationField flowType={flowType} />
			</Suspense>
		</CustomBox>
	);
}
